<div class="community-notifications container-xl py-3" *transloco="let t">
  <header class="d-flex align-items-center justify-content-between flex-wrap gap-2 mb-3">
    <h1 class="h3 mb-0">🔔 {{ t('community.notifications.title') }}</h1>
    <div class="d-flex gap-2">
      <a class="btn btn-outline-secondary btn-sm" [routerLink]="settingsLink()">{{ t('community.settings.title') }}</a>
      <a class="btn btn-outline-secondary btn-sm" [routerLink]="communityLink()">← {{ t('community.thread.back') }}</a>
    </div>
  </header>

  <div class="d-flex align-items-center justify-content-between flex-wrap gap-2 mb-3">
    <div class="form-check">
      <input class="form-check-input" type="checkbox" id="unreadOnly" [checked]="unreadOnly()" (change)="toggleUnreadOnly()" />
      <label class="form-check-label" for="unreadOnly">{{ t('community.notifications.unread_only') }}</label>
    </div>
    <button type="button" class="btn btn-sm btn-link" (click)="markAllRead()">{{ t('community.notifications.mark_all_read') }}</button>
  </div>

  @if (error(); as key) {
    <div class="alert alert-danger">{{ t(key) }}</div>
  }

  @if (loading()) {
    <div class="text-center py-4"><div class="spinner-border" role="status"></div></div>
  } @else if (items().length === 0) {
    <p class="text-muted py-4 text-center">{{ t('community.notifications.empty') }}</p>
  } @else {
    <ul class="list-group">
      @for (n of items(); track n.id) {
        <li class="list-group-item list-group-item-action community-notifications__item" [class.community-notifications__item--unread]="!n.read"
            role="button" (click)="open(n)">
          <div class="d-flex justify-content-between gap-2">
            <strong>{{ n.title }}</strong>
            <small class="text-muted text-nowrap">{{ n.created_at | date:'short' }}</small>
          </div>
          <p class="mb-0 text-muted small">{{ n.body }}</p>
        </li>
      }
    </ul>

    @if (totalPages() > 1) {
      <nav class="d-flex align-items-center justify-content-between mt-3">
        <small class="text-muted">{{ t('community.moderation.total', { count: total() }) }}</small>
        <div class="d-flex gap-2">
          <button type="button" class="btn btn-sm btn-outline-secondary" [disabled]="page() <= 1" (click)="load(page() - 1)">‹</button>
          <span class="align-self-center small text-muted">{{ page() }} / {{ totalPages() }}</span>
          <button type="button" class="btn btn-sm btn-outline-secondary" [disabled]="page() >= totalPages()" (click)="load(page() + 1)">›</button>
        </div>
      </nav>
    }
  }
</div>
